import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getItem } from "../../../../../Store/Store/Item/Item";
import { getParty } from "../../../../../Store/Store/Party/Party";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getGenMaster } from "../../../../../Store/Store/GenralMaster/GenMaster";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import PurReceiveFields from "./components/PurReceiveFields";
import { getTransport } from "../../../../../Store/Store/StoreMaster/Transport/Transport";
import { getPoNo } from "../../../../../Store/prosafe/proTransaction/PurReceive/getPoNo";
import Footer from "../../../Include/Footer";
import PurReceiveItems from "./components/PurReceiveItems";
import { getViewReceiveItems } from "../../../../../Store/prosafe/proTransaction/PurReceive/getViewReceiveItems";
import toast from "react-hot-toast";
import axios from "axios";
import { V_URL } from "../../../../../BaseUrl";

const ManagePurReceive = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState({});
  const [form, setForm] = useState({
    trans_date: moment(Date.now()).format("YYYY-MM-DD"),
    master_id: "",
    project_id: "",
    manual_pro_no: "",
    party_id: "",
    receive_date: moment(Date.now()).format("YYYY-MM-DD"),
    bill_no: "",
    transport_id: "",
    transport_date: "",
    lr_no: "",
    lr_date: "",
    challan_no: "",
    payment_date: "",
    payment_days: "",
    pdf: "",
    vehical_no: "",
    driver_name: "",
  });
  const [itemsArr, setItemsArr] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (error[name]) {
      setError((prev) => {
        const newError = { ...prev };
        delete newError[name];
        return newError;
      });
    }
  };

  const handlePdf = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;
    const fileType = file.type;
    const allowedTypes = {
      pdf: ["application/pdf"],
      image: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
    };
    const fileCategory = Object.keys(allowedTypes).find((type) =>
      allowedTypes[type].includes(fileType)
    );
    if (!fileCategory) {
      toast.error("Invalid file type. Only images and PDFs are allowed.");
      return;
    }
    const uploadUrl = `${V_URL}/upload-image`;
    const formData = new FormData();
    formData.append("image", file);
    axios
      .post(uploadUrl, formData)
      .then((res) => {
        if (res.data.success) {
          const uploaded = res.data.data?.[fileCategory];
          setForm((prev) => ({ ...prev, pdf: uploaded }));
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.response?.data?.message || "Upload failed");
      });
  };

  useEffect(() => {
    dispatch(getGenMaster({ tag_id: 11 }));
    dispatch(getProject());
    dispatch(getParty({ is_main: true }));
    dispatch(getItem({ is_main: true }));
    dispatch(getTransport());
  }, []);

  useEffect(() => {
    if (form.party_id && form.project_id) {
      const formData = new URLSearchParams();
      formData.append("tag_number", 10);
      formData.append("party_id", form.party_id);
      formData.append("project_id", form.project_id);
      formData.append("firm_id", localStorage.getItem("PAY_USER_FIRM_ID"));
      formData.append("year_id", localStorage.getItem("PAY_USER_YEAR_ID"));
      dispatch(getPoNo({ formData }));
    }
  }, [form.party_id, form.project_id]);

  const itemData = useSelector(
    (state) => state?.getViewReceiveItems?.user?.data
  );
  useEffect(() => {
    if (data?._id) {
      dispatch(getViewReceiveItems({ formData: { id: data?._id } }));
      setForm({
        trans_date: moment(data?.trans_date).format("YYYY-MM-DD"),
        master_id: data?.received_by?._id,
        project_id: data?.project_data?._id,
        manual_pro_no: data?.manual_pro_no,
        party_id: data?.party_data?._id,
        receive_date: moment(data?.receive_date).format("YYYY-MM-DD"),
        bill_no: data?.bill_no,
        driver_name: data?.driver_name,
        transport_id: data?.transport_data?._id,
        transport_date: moment(data?.transport_date).format("YYYY-MM-DD"),
        lr_no: data?.lr_no,
        lr_date: moment(data?.lr_date).format("YYYY-MM-DD"),
        challan_no: data?.challan_no,
        payment_date: moment(data?.payment_date).format("YYYY-MM-DD"),
        payment_days: data?.payment_days,
        pdf: data?.pdf,
        vehical_no: data?.vehical_no,
      });
    } else {
      handleReset();
    }
  }, [data]);

  useEffect(() => {
    if (data?._id) {
      if (itemData?.items_details?.length > 0) {
        setItemsArr(itemData.items_details);
      } else {
        setItemsArr([]);
      }
    } else {
      setItemsArr([]);
    }
  }, [itemData, data]);

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    {
      label: "Purchase Receive",
      link: "/main-store/user/purchase-receive-management",
    },
    { label: data?._id ? "Edit" : "Add" + " Purchase Receive", active: true },
  ];

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    const checkRequired = (field, message) => {
      if (!form[field]) {
        newErrors[field] = message;
        isValid = false;
      }
    };
    if (!form.trans_date) {
      newErrors.trans_date = "Date is required";
      isValid = false;
    } else {
      const selectedDate = new Date(form.trans_date);
      const currentDate = new Date();
      if (selectedDate > currentDate) {
        newErrors.trans_date = "Date cannot be in the future";
        isValid = false;
      }
    }
    checkRequired("project_id", "Project is required");
    checkRequired("party_id", "Party is required");
    checkRequired("receive_date", "Receiving Date is required");
    checkRequired("master_id", "Received By is required");
    if (!form.bill_no && !form.challan_no) {
      newErrors.bill_no = "Either Bill No. or Challan No. is required";
      newErrors.challan_no = "Either Bill No. or Challan No. is required";
      isValid = false;
    }
    checkRequired("transport_id", "Transport is required");
    // checkRequired("pdf", "PDF/Image file is required");
    setError(newErrors);
    return isValid;
  };

  const validateItems = () => {
    if (!itemsArr || itemsArr.length === 0) {
      toast.error("At least one item is required");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }
    if (!validateItems()) {
      return;
    }
    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-add-one-pu`;

    const formData = new URLSearchParams();
    formData.append("firm_id", localStorage.getItem("PAY_USER_FIRM_ID"));
    formData.append("year_id", localStorage.getItem("PAY_USER_YEAR_ID"));
    formData.append("tag_number", 11);
    formData.append("trans_date", form.trans_date);
    formData.append("master_id", form.master_id);
    formData.append("project_id", form.project_id);
    formData.append("manual_pro_no", form.manual_pro_no);
    formData.append("party_id", form.party_id);
    formData.append("receive_date", form.receive_date);
    formData.append("bill_no", form.bill_no);
    formData.append("transport_id", form.transport_id);
    formData.append("transport_date", form.transport_date);
    formData.append("lr_no", form.lr_no);
    formData.append("lr_date", form.lr_date);
    formData.append("challan_no", form.challan_no);
    formData.append("payment_date", form.payment_date);
    formData.append("payment_days", form.payment_days);
    formData.append("pdf", form.pdf);
    formData.append("vehical_no", form.vehical_no);
    formData.append("items_details", JSON.stringify(itemsArr));

    axios({
      method: "post",
      url: myurl,
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/purchase-receive-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const handleUpdate = () => {
    if (!validateForm()) {
      return;
    }

    if (!validateItems()) {
      return;
    }
    
    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-update-pu`;

    // const formData = new URLSearchParams();
    // formData.append("id", data?._id);
    // formData.append("trans_date", form.trans_date);
    // formData.append("bill_no", form.bill_no);
    // formData.append("challan_no", form.challan_no);
    // formData.append("master_id", form.master_id);
    // formData.append("receive_date", form.receive_date);
    // formData.append("transport_id", form.transport_id);
    // formData.append("transport_date", form.transport_date);
    // formData.append("vehical_no", form?.vehical_no || "");
    // formData.append("payment_date", form?.payment_date || "");
    // formData.append("payment_days", form?.payment_days || "");
    // formData.append("lr_no", form?.lr_no || "");
    // formData.append("lr_date", form?.lr_date || "");
    // formData.append("pdf", form?.pdf);
    // formData.append("driver_name", form?.driver_name || "");

    

    const payload = {
      id: data?._id,
      trans_date:
        form?.trans_date && moment(form.trans_date).isValid()
          ? moment(form.trans_date).format("YYYY-MM-DD")
          : null,
      bill_no: form.bill_no,
      challan_no: form.challan_no,
      manual_pro_no: form.manual_pro_no,
      master_id: form.master_id,
      receive_date:
        form?.receive_date && moment(form.receive_date).isValid()
          ? moment(form.receive_date).format("YYYY-MM-DD")
          : null,
      transport_id: form.transport_id ? form.transport_id : null,
      transport_date:
        form?.transport_date && moment(form.transport_date).isValid()
          ? moment(form.transport_date).format("YYYY-MM-DD")
          : null,
      vehical_no: form?.vehical_no ? form?.vehical_no : null,
      payment_date:
        form?.payment_date && moment(form.payment_date).isValid()
          ? moment(form.payment_date).format("YYYY-MM-DD")
          : null,
      payment_days: form?.payment_days ? form?.payment_days : null,
      lr_no: form?.lr_no ? form?.lr_no : null,
      lr_date:
        form?.lr_date && moment(form.lr_date).isValid()
          ? moment(form.lr_date).format("YYYY-MM-DD")
          : null,
      pdf: form?.pdf,
      driver_name: form?.driver_name ? form?.driver_name : null,
    };

    axios({
      method: "put",
      url: myurl,
      data: payload,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/purchase-receive-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const handleReset = () => {
    setForm({
      trans_date: moment(Date.now()).format("YYYY-MM-DD"),
      master_id: "",
      project_id: "",
      manual_pro_no: "",
      party_id: "",
      receive_date: moment(Date.now()).format("YYYY-MM-DD"),
      bill_no: "",
      transport_id: "",
      transport_date: "",
      lr_no: "",
      lr_date: "",
      challan_no: "",
      payment_date: "",
      payment_days: "",
      pdf: "",
      vehical_no: "",
    });
    setItemsArr([]);
    setError({});
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>
                          {data?._id ? "Edit" : "Add"} Purchase Receiving
                          Details
                        </h4>
                      </div>
                    </div>
                    <PurReceiveFields
                      form={form}
                      handleChange={handleChange}
                      handlePdf={handlePdf}
                      error={error}
                      data={data}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>

          <PurReceiveItems
            itemsArr={itemsArr}
            setItemsArr={setItemsArr}
            form={form}
            data={data}
          />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button
                        type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={data?._id ? handleUpdate : handleSubmit}
                        disabled={disable && !data?._id}
                      >
                        {disable
                          ? "Processing..."
                          : data?._id
                          ? "Update"
                          : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel-form"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ManagePurReceive;
